import { GemUser } from 'app/models/api/gem-user';

export class AuthToken {
    constructor(
        public token: string,
        public user: GemUser,
    ) {}
}
